"use client";

import {
	RecommendedProducts,
	type RecommendedProductsProps
} from "@pamperedchef/consumer-components/product";

import { analyticsManager } from "@/app/utilities/analytics/analytics-manager";

/** PDP must read "PDP Product Recommendation" to match the legacy Hybris payload. */
const ITEM_LIST_NAME: Record<RecommendedProductsProps["source"], string> = {
	PDP: "PDP Product Recommendation",
	ATC: "ATC Product Recommendation",
	CONSUMER_CART: "Cart Product Recommendation"
};

// A plain Omit collapses the source/sku union, which is what keeps a PDP
// without a sku from compiling.
type DistributiveOmit<T, K extends PropertyKey> = T extends unknown
	? Omit<T, K>
	: never;

export type RecommendedProductsBlockProps = DistributiveOmit<
	RecommendedProductsProps,
	"onImpression"
>;

/**
 * The shared recommendations carousel with this app's analytics attached. The
 * component owns its own request; cart handling stays with `CartEventBridge`,
 * which already listens for the `pc:add-to-cart` event each card dispatches.
 */
export function RecommendedProductsBlock(
	props: RecommendedProductsBlockProps
): JSX.Element {
	return (
		<RecommendedProducts
			{...props}
			onImpression={(items) =>
				analyticsManager.track({
					type: "view_item_list",
					itemListName: ITEM_LIST_NAME[props.source],
					skus: items.map((item) => item.sku)
				})
			}
		/>
	);
}
